import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
Vue.config.productionTip = false
//============in-built plugins===============
import Notifications from 'vue-notification'
Vue.use(Notifications)

import FlipCountdown from 'vue2-flip-countdown'
Vue.component('flip-countdown', FlipCountdown)

import VieOtpInput from "@bachdgvn/vue-otp-input"
Vue.component("vie-otp-input", VieOtpInput);

import VueFeather from 'vue-feather';
Vue.use(VueFeather);

import pdf from 'vue-pdf'
Vue.component('vue-pdf', pdf)

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import vueShapeImg from 'vueshapeimg'
Vue.use(vueShapeImg)

import VueClipboard from 'vue-clipboard2' 
Vue.use(VueClipboard)

import Datepicker from 'vue2-datepicker';
Vue.component('datepicker', Datepicker)

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)



import Paginate from 'vuejs-paginate';
Vue.component('paginate', Paginate);

import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll)

import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/spell_checker.min';
import 'froala-editor/js/third_party/image_tui.min';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)

//=========phone number with country code========
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
Vue.component('vue-phone-number-input', VuePhoneNumberInput);

Vue.use(require('vue-moment'));

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.$cookies.config('30d')
Vue.$cookies.config('7d', '', '', true)
//=================import mixins=================================
// import registerStepsMixins from './plugins/registerSteps/index.ts';
// Vue.mixin(registerStepsMixins);

import commonAllmixins from './plugins/commonAll/index.ts';
Vue.mixin(commonAllmixins);

// import supportMixins from './plugins/support/index.ts';
// Vue.mixin(supportMixins);

// import tradingMixins from './plugins/trading/index.ts';
// Vue.mixin(tradingMixins);

//=================import env variable===========================
Vue.prototype.$env_var = process.env
import * as moment from 'moment'
//===================import components ===========================
import loader from './components/website/shared/loader'
Vue.component('loader', loader)
import alert_notification from './components/website/shared/alert-notification'
Vue.component('alert-notification', alert_notification)
import table_loader from './components/website/shared/table_loader'
Vue.component('table-loader', table_loader)
import no_data from './components/website/shared/no-data'
Vue.component('no-data', no_data)
import header from './components/website/shared/header'
Vue.component('app-header', header)
import password_icon from './components/website/shared/password_icon'
Vue.component('passwordIcon', password_icon)
import pagination from './components/website/shared/pagination'
Vue.component('pagination', pagination)
import change_account from './components/website/shared/change-account'
Vue.component('change-account', change_account)
    //===============================================================


// ChartIQ
// window._     = require('../static/website/js/chartiq.js');
// window.__     = require('../static/website/js/quoteFeedSimulator.js');

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js